// extracted by mini-css-extract-plugin
module.exports = {"pt-hospital-table":"pt-hospital-table-d826c04cd606b8ac1aedb5d0a46154ca","download-qrcode":"download-qrcode-d5061e05a06c51f371e87617e1061c7c"};